import React from 'react'
import "./imprint.css"

import {useTranslate} from "../../Context/LanguageContext"

const Imprint = () => {
    const t = useTranslate("imprint")

    return ( 
        <section id='imprint'>
            <h1>{t("title")}</h1>

            <div className='wrapper'>
                <p>{t("name")}</p>
                <p>{t("street")}</p>
                <p>{t("zip")}</p>
                <p>{t("country")}</p>
            </div>

            <div className='wrapper'>
                <p className='heading'>{t("ceo")}</p>
                <p>{t("graduate")}</p>
                <p className='heading'>{t("vat")}</p>
                <p>DE223991220</p>
                <p className='heading'>{t("court")}</p>
                <p>{t("court-name")}</p>
            </div>

            <div className='wrapper'>
                <p className='heading'>{t("liability")}</p>
                <p>{t("liability-text")}</p>
            </div>
            <div className='wrapper'>
                <p className='heading'>{t("copyright")}</p>
                <p>{t("copyright-text")}</p>
            </div>
            <div className='wrapper'>
                <p className='heading'>{t("privacy-policy")}</p>
                <p>{t("privacy-policy-text")}</p>
            </div>
        </section> 
    );
}
 
export default Imprint;